module.exports = __webpack_public_path__ + "static/fonts/Fact-CompressedBlack.8080593.woff2";